import React from "react";

export default function CloudUpload() {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="16"
      height="17"
      fill="none"
      viewBox="0 0 16 17"
    >
      <g clipPath="url(#clip0_2480_3682)">
        <path fill="#fff" d="M8 7.167v8-8z"></path>
        <path
          stroke="#fff"
          strokeLinecap="round"
          strokeLinejoin="round"
          strokeWidth="2"
          d="M4.666 11.166a2.666 2.666 0 01-.587-5.268A3.334 3.334 0 0110.6 4.5h.067a3.333 3.333 0 01.666 6.6M10 9.167l-2-2m0 0l-2 2m2-2v8"
        ></path>
      </g>
      <defs>
        <clipPath id="clip0_2480_3682">
          <path
            fill="#fff"
            d="M0 0H16V16H0z"
            transform="translate(0 .5)"
          ></path>
        </clipPath>
      </defs>
    </svg>
  );
}
